import React, { useState, useEffect } from 'react';
import Loader from '../../components/Loader';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminInquiries = () => {
  const [activeTab, setActiveTab] = useState('contact');
  const [data, setData] = useState({ contact: [], booking: [], promo: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAllInquiries();
  }, []);

  const fetchAllInquiries = async () => {
    try {
      const [contact, booking, promo] = await Promise.all([
        fetch(`${API_URL}/api/admin/contact-submissions`).then(r => r.json()),
        fetch(`${API_URL}/api/admin/booking-inquiries`).then(r => r.json()),
        fetch(`${API_URL}/api/admin/promo-inquiries`).then(r => r.json())
      ]);
      setData({ contact, booking, promo });
    } catch (err) {
      console.error('Error fetching inquiries:', err);
    } finally {
      setLoading(false);
    }
  };

  const tabs = [
    { id: 'contact', label: 'Contact Submissions', count: data.contact.length },
    { id: 'booking', label: 'Booking Inquiries', count: data.booking.length },
    { id: 'promo', label: 'Promo Inquiries', count: data.promo.length },
  ];

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('en-IN', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="admin-inquiries">
      <div className="admin-page-header">
        <h1>Inquiries</h1>
        <p>View all customer inquiries and submissions</p>
      </div>

      <div className="admin-tabs">
        {tabs.map(tab => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`admin-tab ${activeTab === tab.id ? 'active' : ''}`}
          >
            {tab.label}
            <span className="tab-count">{tab.count}</span>
          </button>
        ))}
      </div>

      <div className="admin-table-wrapper">
        {activeTab === 'contact' && (
          <table className="admin-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {data.contact.map(item => (
                <tr key={item.id}>
                  <td>{item.firstName} {item.lastName}</td>
                  <td><a href={`tel:${item.phone}`}>{item.phone}</a></td>
                  <td><a href={`mailto:${item.email}`}>{item.email}</a></td>
                  <td>{formatDate(item.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {activeTab === 'booking' && (
          <table className="admin-table">
            <thead>
              <tr>
                <th>From → To</th>
                <th>Destination</th>
                <th>Dates</th>
                <th>Travelers</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {data.booking.map(item => (
                <tr key={item.id}>
                  <td>{item.travelFrom} → {item.travelTo}</td>
                  <td>{item.specificDestination}</td>
                  <td>{item.startDate} - {item.endDate}</td>
                  <td>{item.adults}A, {item.children}C</td>
                  <td>{formatDate(item.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {activeTab === 'promo' && (
          <table className="admin-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {data.promo.map(item => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td><a href={`tel:${item.phone}`}>{item.phone}</a></td>
                  <td><a href={`mailto:${item.email}`}>{item.email}</a></td>
                  <td>{formatDate(item.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {data[activeTab].length === 0 && (
          <div className="admin-empty">
            <i className="fa-solid fa-inbox"></i>
            <p>No inquiries yet</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminInquiries;
